import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { ReadStateOrDefault } from "source/app/services/UI/State/ReadState";
import { SetState } from "source/app/services/UI/State/SetState";

export function ToggleUseAnopenscrollFontAsync() {
    const currentValue = ReadStateOrDefault(
        ESharedFunction.FontSwitcher_useAnopenscrollFont,
        false
    );

    return SetUseAnopenscrollFontAsync(!currentValue);
}

export function SetUseAnopenscrollFontAsync(useAnopenscrollFont: boolean) {
    return SetState<boolean>(
        ESharedFunction.FontSwitcher_useAnopenscrollFont,
        useAnopenscrollFont
    );
}
